export default {
  tag: 'Testi',
  tag_tooltip: 'Testiravintola: toimii täysin, ei koskaan laskuteta.',
  card: {
    title: 'Testiravintola',
    description:
      'Merkitse yksi ravintola testiravintolaksi kokeillaksesi tulostusta, sähköposteja, tilauksia ja integraatioita tuotannossa. Se toimii kuten mikä tahansa muu ravintola eikä sitä koskaan laskuteta. Sen tilauksiin liittyvät asiakkaan sähköpostit ja tekstiviestit alkavat merkinnällä [TEST].',
    payments_note:
      'Testiravintolan maksut ovat oikeita ja ne maksetaan ulos kuten muutkin. Palauta testitilaukset itse. Meille ilmoitetaan, kun sen kuukausimyynti kasvaa testausta suuremmaksi.',
    designated_on: 'Merkitty testiksi {{date}}',
    open_shop: 'Avaa kauppa',
    remove: 'Poista testimerkintä',
    select_placeholder: 'Valitse ravintola',
    mark: 'Merkitse testiravintolaksi',
    no_restaurants: 'Sinulla ei ole vielä merkittävää ravintolaa.',
    load_error: 'Testiravintolaasi ei voitu ladata.',
  },
  remove_confirm: {
    title: 'Poistetaanko testimerkintä ravintolalta {{name}}?',
    description_live:
      'Tämän ravintolan laskutus jatkuu, ja se menee heti offline-tilaan. Käynnistä se uudelleen kohdasta Tilausasetukset → Tilaustavat → Live-tilaukset, jossa valitset sen hintapaketin.',
    description_stays_live:
      'Tämä ravintola pysyy live-tilassa ja sitä kohdellaan nyt taas kuten muitakin ravintoloitasi.',
    description_offline:
      'Tämän ravintolan laskutus jatkuu, kun se menee live-tilaan. Sen hintapaketti valitaan käynnistyksen yhteydessä.',
    confirm: 'Poista testimerkintä',
  },
  toasts: {
    designated: '{{name}} on nyt testiravintolasi. Sitä ei laskuteta.',
    designate_error: 'Ravintolaa ei voitu merkitä testiksi. Yritä uudelleen.',
    removed: '{{name}} ei ole enää testiravintolasi.',
    removed_offline: '{{name}} ei ole enää testiravintolasi ja on nyt offline-tilassa.',
    remove_error: 'Testimerkintää ei voitu poistaa. Yritä uudelleen.',
  },
};
